/**
 * This is the popup component for the disclaimer.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=19666-59865&m=dev
 */
const Details = (): React.ReactElement => {
  return (
    <div
      data-testid="popup-component"
      className="p-6 text-left font-poppins text-xs leading-6 tracking-normal"
    >
      <h3 className="mb-4 font-poppins text-lg font-semibold leading-6 tracking-5%">
        UNDERSTANDING <br className="md:hidden" />
        DEEPERDIVE (BETA)
      </h3>

      <p className="mb-4">
        DeeperDive is an experimental Artificial Intelligence (AI) feature
        powered by our technology partner, Taboola, designed to help you explore
        our news content.
      </p>

      <p className="mb-4">
        As frontier technologies such as AI and large language models are
        continually developing, you acknowledge that:
      </p>

      <ol className="list-decimal pl-5">
        <li>
          DeeperDive may generate outputs that are inaccurate, incomplete,
          misleading, or provide unexpected content that does not represent the
          views of SPH Media.
        </li>

        <li>
          {
            "DeeperDive's outputs are not intended to be your sole source of factual information, and you should refer to the original, full-text article written by our journalists for the full picture."
          }
        </li>

        <li>
          SPH Media provides news and information, not advisory services. Please
          do not rely on DeeperDive or its summaries for financial, legal,
          medical, or any other professional advice.
        </li>

        <li>
          Please do not enter any personal, confidential, or sensitive
          information (such as your name, contact details, financial
          information, or passwords) into the DeeperDive tool.
        </li>
      </ol>
    </div>
  );
};

export default Details;
